export default "__VITE_ASSET__MV2v6Y3b__"